import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";

/**
 * Context for providing timezone information to child components
 * This is typically set at the project level and consumed by all nested pages
 */
const TimezoneContext = createContext("America/Denver"); // Default to Mountain Time

/**
 * Hook to access the current timezone from context
 * @returns {string} - The timezone identifier (e.g., "America/Denver" or "Europe/London")
 */
export const useTimezone = () => {
  return useContext(TimezoneContext);
};

/**
 * Provider component for timezone context
 * Should be wrapped around project-level pages
 */
export const TimezoneProvider = ({ timezone, children }) => {
  return (
    <TimezoneContext.Provider value={timezone}>
      {children}
    </TimezoneContext.Provider>
  );
};

TimezoneProvider.propTypes = {
  timezone: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default TimezoneContext;
